import React from 'react';
import Grid from '@mui/material/Grid';
import {RedirectLogin} from 'lib.front';
import {transformacion} from 'lib.common';
import * as keys from 'src/config/keys';

function RedirectLoginView() {
   const paramsQuery = transformacion.getHashQueryString(window.location.search);
   const callbackURI = transformacion
      .appendUrl(
         transformacion.appendUrl(window.location.origin, keys.baseName),
         keys.callbackRoute
      )
      .toString();
   return (
      <Grid container justifyItems="center" style={{height: '100%', paddingTop: '10%'}}>
         <Grid item xs={12}>
            <RedirectLogin
               appName={keys.appName}
               LoginApiURI={keys.dsloginUrl}
               originURI={paramsQuery['origin_uri']}
               callbackURI={callbackURI}
               appId={keys.appId}
               scope={keys.appScope}
               redirect={true}
               mostrarRedirectLink={false}
            />
         </Grid>
      </Grid>
   );
}

export default RedirectLoginView;
